import { GuestState } from './guestStore';

export const delsysCodeSelector = (state: GuestState) =>
  state.guestPlanSelectorData?.delsysCode;
